import openvpn from "./openvpn.json";
import pptp from "./pptp.json";
import ikev2 from "./ikev2.json";
import l2tp from "./l2tp.json";
import vless from "./vless.json";

export default { openvpn, pptp, ikev2, l2tp, vless };
